import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getSMAList, { getUrl } from "../requests/getSMAList";
import { SMAAsset, SMAAssetId } from "../requests/Types";
export { SMAAsset, SMAAssetId };
export const keyMaker = () => [getUrl()];
const useSMAAssetList = makeZeroArgHook(getSMAList, keyMaker);
export default useSMAAssetList;
//# sourceMappingURL=useSMAAssetList.js.map